<template>
  <div class="w-full">
    <div
      class="flex flex-col sm:flex-row sm:items-center justify-between items-start gap-3 sm:gap-4 mb-6 sm:mb-8 bg-gradient-to-br from-[var(--p-primary-500)] to-[var(--p-primary-600)] rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 text-white shadow-[0_8px_32px_rgba(0,0,0,0.1)]"
    >
      <div class="flex items-center gap-3 sm:gap-4 min-w-0 flex-1">
        <div
          class="w-9 h-9 sm:w-11 sm:h-11 bg-white/20 rounded-xl flex items-center justify-center text-lg sm:text-xl flex-shrink-0"
        >
          <i class="pi pi-chart-line"></i>
        </div>
        <div class="flex flex-col min-w-0 flex-1">
          <h2 class="text-xl sm:text-2xl font-bold m-0 truncate">Performance Tracker</h2>
          <p class="text-xs sm:text-sm opacity-90 mt-1 mb-0 line-clamp-1">
            Monitor your used car turnover performance
          </p>
        </div>
      </div>
    </div>

    <div
      v-if="!isDataLoaded || (isUpdating && !hasNoData)"
      class="flex flex-col lg:flex-row items-center lg:items-start justify-center gap-4 sm:gap-6"
    >
      <div
        class="flex-shrink-0 w-full sm:max-w-[400px] md:max-w-[615px] flex justify-center lg:justify-start"
      >
        <div class="relative w-full lg:max-w-[650px]">
          <div class="relative w-full">
            <div
              class="w-full sm:max-w-[400px] md:max-w-[500px] lg:max-w-[650px] aspect-square bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 shadow-[0_25px_50px_-12px_rgba(0,0,0,0.15),0_10px_20px_-5px_rgba(0,0,0,0.1),0_0_0_1px_rgba(0,0,0,0.05)] border-2 border-[var(--p-surface-100)] animate-pulse"
            >
              <div class="w-full h-full rounded-full bg-[var(--p-surface-100)]"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex-1 w-full xl:w-auto flex flex-col">
        <div class="mb-4 sm:mb-6 flex justify-start sm:justify-end">
          <div
            class="flex w-full sm:w-[49%] gap-2 sm:gap-3 p-3 sm:p-4 bg-white rounded-lg border border-[var(--p-surface-200)] shadow-sm"
          >
            <div
              class="w-5 h-5 bg-[var(--p-surface-200)] rounded animate-pulse flex-shrink-0"
            ></div>
            <div class="h-4 w-full sm:w-48 bg-[var(--p-surface-200)] rounded animate-pulse"></div>
          </div>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
          <div
            class="bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-[0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] border border-[var(--p-surface-200)]"
          >
            <div class="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3">
              <div
                class="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-[var(--p-surface-200)] animate-pulse flex-shrink-0"
              ></div>
              <div class="h-4 w-full sm:w-32 bg-[var(--p-surface-200)] rounded animate-pulse"></div>
            </div>
            <div
              class="h-6 sm:h-8 w-full sm:w-32 bg-[var(--p-surface-200)] rounded mb-2 animate-pulse"
            ></div>
            <div
              class="h-3 sm:h-4 w-full sm:w-16 bg-[var(--p-surface-200)] rounded animate-pulse"
            ></div>
          </div>
          <div
            class="bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-[0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] border border-[var(--p-surface-200)]"
          >
            <div class="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3">
              <div
                class="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-[var(--p-surface-200)] animate-pulse flex-shrink-0"
              ></div>
              <div class="h-4 w-full sm:w-32 bg-[var(--p-surface-200)] rounded animate-pulse"></div>
            </div>
            <div
              class="h-6 sm:h-8 w-full sm:w-32 bg-[var(--p-surface-200)] rounded mb-2 animate-pulse"
            ></div>
            <div
              class="h-3 sm:h-4 w-full sm:w-16 bg-[var(--p-surface-200)] rounded animate-pulse"
            ></div>
          </div>
          <div
            class="bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-[0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] border border-[var(--p-surface-200)]"
          >
            <div class="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3">
              <div
                class="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-[var(--p-surface-200)] animate-pulse flex-shrink-0"
              ></div>
              <div class="h-4 w-full sm:w-32 bg-[var(--p-surface-200)] rounded animate-pulse"></div>
            </div>
            <div
              class="h-6 sm:h-8 w-full sm:w-32 bg-[var(--p-surface-200)] rounded mb-2 animate-pulse"
            ></div>
            <div
              class="h-3 sm:h-4 w-full sm:w-16 bg-[var(--p-surface-200)] rounded animate-pulse"
            ></div>
          </div>
          <div
            class="bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-[0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] border border-[var(--p-surface-200)]"
          >
            <div class="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3">
              <div
                class="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-[var(--p-surface-200)] animate-pulse flex-shrink-0"
              ></div>
              <div class="h-4 w-full sm:w-32 bg-[var(--p-surface-200)] rounded animate-pulse"></div>
            </div>
            <div
              class="h-6 sm:h-8 w-full sm:w-32 bg-[var(--p-surface-200)] rounded mb-2 animate-pulse"
            ></div>
            <div
              class="h-3 sm:h-4 w-full sm:w-16 bg-[var(--p-surface-200)] rounded animate-pulse"
            ></div>
          </div>
          <div
            class="bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-[0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] border border-[var(--p-surface-200)]"
          >
            <div class="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3">
              <div
                class="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-[var(--p-surface-200)] animate-pulse flex-shrink-0"
              ></div>
              <div class="h-4 w-full sm:w-32 bg-[var(--p-surface-200)] rounded animate-pulse"></div>
            </div>
            <div
              class="h-6 sm:h-8 w-full sm:w-32 bg-[var(--p-surface-200)] rounded mb-2 animate-pulse"
            ></div>
            <div
              class="h-3 sm:h-4 w-full sm:w-16 bg-[var(--p-surface-200)] rounded animate-pulse"
            ></div>
          </div>
          <div
            class="bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-[0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] border border-[var(--p-surface-200)]"
          >
            <div class="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3">
              <div
                class="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-[var(--p-surface-200)] animate-pulse flex-shrink-0"
              ></div>
              <div class="h-4 w-full sm:w-32 bg-[var(--p-surface-200)] rounded animate-pulse"></div>
            </div>
            <div
              class="h-6 sm:h-8 w-full sm:w-32 bg-[var(--p-surface-200)] rounded mb-2 animate-pulse"
            ></div>
            <div
              class="h-3 sm:h-4 w-full sm:w-16 bg-[var(--p-surface-200)] rounded animate-pulse"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="!hasNoData && !isUpdating">
      <div
        class="flex flex-col lg:flex-row items-center lg:items-start justify-center gap-4 sm:gap-6"
      >
        <div
          class="flex-shrink-0 w-full sm:max-w-[400px] md:max-w-[615px] flex justify-center lg:justify-start"
        >
          <div class="relative w-full lg:max-w-[650px]">
            <div class="relative w-full">
              <SegmentedCircle
                :progressData="{
                  actualTurnover: actualTurnoverRaw,
                  anticipatedVolume: usedAnticipatedRaw,
                  currentMonth: new Date().getMonth(),
                }"
                :isDataLoaded="isDataLoaded"
              />
              <div
                class="absolute inset-0 flex flex-col items-center justify-center text-center pointer-events-none"
              >
                <div class="mb-2 sm:mb-4">
                  <div
                    class="w-12 h-12 sm:w-20 sm:h-20 mx-auto rounded-xl sm:rounded-2xl bg-gradient-to-br from-[var(--p-primary-100)] to-[var(--p-primary-200)] flex items-center justify-center shadow-lg"
                  >
                    <i class="pi pi-car !text-2xl sm:!text-5xl text-[var(--p-primary-600)]"></i>
                  </div>
                </div>
                <div
                  class="text-[9px] sm:text-sm font-semibold text-[var(--p-anthracite-500)] uppercase tracking-wider mb-2 sm:mb-4 px-2"
                >
                  Used Turnover Performance
                </div>
                <div class="flex items-baseline justify-center gap-1 sm:gap-2 mb-2 sm:mb-3">
                  <span
                    class="text-2xl sm:text-5xl lg:text-6xl font-extrabold text-[var(--p-primary-600)] transition-all duration-300 relative tracking-tight"
                    >{{ usedTurnoverPerformance.toFixed(2) }}</span
                  >
                  <span class="text-3xl sm:text-4xl font-bold text-[var(--p-primary-500)]">%</span>
                </div>
                <div
                  class="text-[9px] sm:text-sm font-medium text-[var(--p-anthracite-500)] px-4 sm:px-6"
                >
                  Achieved vs Anticipated Volume
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Metrics Section -->
        <div class="flex-1 w-full xl:w-auto flex flex-col">
          <div class="mb-4 sm:mb-6 flex justify-start sm:justify-end">
            <div
              class="flex items-center gap-2 sm:gap-3 px-3 sm:px-5 py-2.5 sm:py-3.5 bg-gradient-to-r from-[var(--p-surface-50)] to-white rounded-lg sm:rounded-xl border border-[var(--p-surface-200)] shadow-sm hover:shadow-md transition-all duration-200 group w-full sm:w-auto"
            >
              <Checkbox
                v-model="includeProposedNotFunded"
                inputId="includeProposed"
                :binary="true"
                @change="handleIncludeProposedChange"
                class="group-hover:scale-110 transition-transform duration-200 flex-shrink-0"
              />
              <label
                for="includeProposed"
                class="text-xs sm:text-sm font-semibold text-[var(--p-anthracite-500)] cursor-pointer select-none group-hover:text-[var(--p-primary-600)] transition-colors duration-200"
              >
                Include Accepted Not Funded Cases
              </label>
            </div>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
            <div
              class="group relative bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-[0_10px_25px_-5px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] border border-[var(--p-surface-200)] transition-all duration-300 animate-[fadeInUp_0.6s_ease-out] hover:shadow-[0_15px_35px_-5px_rgba(0,0,0,0.15),0_6px_10px_-3px_rgba(0,0,0,0.1)] hover:-translate-y-1 hover:border-[var(--p-tangerine-300)] overflow-hidden"
              v-tooltip.left="
                'This is the total projected Used car finance turnover for the calendar year based on current run rate.'
              "
            >
              <div
                class="absolute inset-0 bg-gradient-to-br from-[var(--p-tangerine-50)]/0 to-[var(--p-tangerine-50)]/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
              ></div>
              <div class="relative">
                <div class="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3">
                  <div
                    class="w-9 h-9 sm:w-10 sm:h-10 rounded-lg sm:rounded-xl flex items-center justify-center text-white bg-gradient-to-br from-[var(--p-tangerine-500)] to-[var(--p-tangerine-600)] shadow-md group-hover:scale-105 transition-transform duration-300 flex-shrink-0"
                  >
                    <i class="pi pi-pound !text-base sm:!text-lg text-white"></i>
                  </div>
                  <div
                    class="text-sm sm:text-base font-bold text-[var(--p-anthracite-500)] min-w-0 flex-1"
                  >
                    Projected Used Turnover
                  </div>
                </div>
                <div
                  class="text-xl sm:text-2xl font-bold text-[var(--p-primary-600)] mb-1 sm:mb-2 transition-all duration-300 relative tracking-tight break-words"
                >
                  {{ formatCurrency.format(totalTurnover) }}
                </div>
              </div>
            </div>

            <div
              class="group relative bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-[0_10px_25px_-5px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] border border-[var(--p-surface-200)] transition-all duration-300 animate-[fadeInUp_0.6s_ease-out_0.1s] hover:shadow-[0_15px_35px_-5px_rgba(0,0,0,0.15),0_6px_10px_-3px_rgba(0,0,0,0.1)] hover:-translate-y-1 hover:border-[var(--p-mint-300)] overflow-hidden"
              v-tooltip.left="
                'This is the actual Used car finance turnover funded so far for the calendar year.'
              "
            >
              <div
                class="absolute inset-0 bg-gradient-to-br from-[var(--p-mint-50)]/0 to-[var(--p-mint-50)]/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
              ></div>
              <div class="relative">
                <div class="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3">
                  <div
                    class="w-9 h-9 sm:w-10 sm:h-10 rounded-lg sm:rounded-xl flex items-center justify-center text-white bg-gradient-to-br from-[var(--p-mint-500)] to-[var(--p-mint-600)] shadow-md group-hover:scale-105 transition-transform duration-300 flex-shrink-0"
                  >
                    <i class="pi pi-chart-bar !text-base sm:!text-lg text-white"></i>
                  </div>
                  <div
                    class="text-sm sm:text-base font-bold text-[var(--p-anthracite-500)] min-w-0 flex-1"
                  >
                    Actual Used Turnover
                  </div>
                </div>
                <div
                  class="text-xl sm:text-2xl font-bold text-[var(--p-primary-600)] mb-1 sm:mb-2 transition-all duration-300 relative tracking-tight break-words"
                >
                  {{ formatCurrency.format(actualTurnover) }}
                </div>
              </div>
            </div>

            <div
              class="group relative bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-[0_10px_25px_-5px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] border border-[var(--p-surface-200)] transition-all duration-300 animate-[fadeInUp_0.6s_ease-out_0.3s] hover:shadow-[0_15px_35px_-5px_rgba(0,0,0,0.15),0_6px_10px_-3px_rgba(0,0,0,0.1)] hover:-translate-y-1 hover:border-[var(--p-primary-300)] overflow-hidden"
              v-tooltip.left="
                'This is the agreed anticipated used volume with Stellantis Financial Services for this calendar year.'
              "
            >
              <div
                class="absolute inset-0 bg-gradient-to-br from-[var(--p-primary-50)]/0 to-[var(--p-primary-50)]/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
              ></div>
              <div class="relative">
                <div class="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3">
                  <div
                    class="w-9 h-9 sm:w-10 sm:h-10 rounded-lg sm:rounded-xl flex items-center justify-center text-white bg-gradient-to-br from-[var(--p-primary-500)] to-[var(--p-primary-600)] shadow-md group-hover:scale-105 transition-transform duration-300 flex-shrink-0"
                  >
                    <i class="pi pi-flag !text-base sm:!text-lg text-white"></i>
                  </div>
                  <div
                    class="text-sm sm:text-base font-bold text-[var(--p-anthracite-500)] min-w-0 flex-1"
                  >
                    Used Anticipated Volume
                  </div>
                </div>
                <div
                  class="text-xl sm:text-2xl font-bold text-[var(--p-primary-600)] mb-1 sm:mb-2 transition-all duration-300 relative tracking-tight break-words"
                >
                  {{ formatCurrency.format(usedAnticipated) }}
                </div>
              </div>
            </div>

            <div
              class="group relative bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-[0_10px_25px_-5px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] border border-[var(--p-surface-200)] transition-all duration-300 animate-[fadeInUp_0.6s_ease-out_0.35s] hover:shadow-[0_15px_35px_-5px_rgba(0,0,0,0.15),0_6px_10px_-3px_rgba(0,0,0,0.1)] hover:-translate-y-1 hover:border-[var(--p-orange-300)] overflow-hidden"
              v-tooltip.left="
                'This is the amount remaining until the anticipated volume is reached for this period.'
              "
            >
              <div
                class="absolute inset-0 bg-gradient-to-br from-[var(--p-orange-50)]/0 to-[var(--p-orange-50)]/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
              ></div>
              <div class="relative">
                <div class="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3">
                  <div
                    class="w-9 h-9 sm:w-10 sm:h-10 rounded-lg sm:rounded-xl flex items-center justify-center text-white bg-gradient-to-br from-[var(--p-orange-500)] to-[var(--p-orange-600)] shadow-md group-hover:scale-105 transition-transform duration-300 flex-shrink-0"
                  >
                    <i class="pi pi-clock !text-base sm:!text-lg text-white"></i>
                  </div>
                  <div
                    class="text-sm sm:text-base font-bold text-[var(--p-anthracite-500)] min-w-0 flex-1"
                  >
                    Turnover Until Anticipated Volume
                  </div>
                </div>
                <div
                  class="text-xl sm:text-2xl font-bold text-[var(--p-primary-600)] mb-1 sm:mb-2 transition-all duration-300 relative tracking-tight break-words"
                >
                  {{ formatCurrency.format(untilAnticipated) }}
                </div>
              </div>
            </div>

            <div
              class="group relative bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-[0_10px_25px_-5px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] border border-[var(--p-surface-200)] transition-all duration-300 animate-[fadeInUp_0.6s_ease-out_0.25s] hover:shadow-[0_15px_35px_-5px_rgba(0,0,0,0.15),0_6px_10px_-3px_rgba(0,0,0,0.1)] hover:-translate-y-1 hover:border-[var(--p-primary-300)] overflow-hidden"
              v-tooltip.left="
                'This is the total used car finance commission earned year to date for the selected scope.'
              "
            >
              <div
                class="absolute inset-0 bg-gradient-to-br from-violet-50/0 to-violet-50/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
              ></div>
              <div class="relative">
                <div class="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3">
                  <div
                    class="w-9 h-9 sm:w-10 sm:h-10 rounded-lg sm:rounded-xl flex items-center justify-center text-white bg-gradient-to-br from-[var(--p-tangerine-500)] to-[var(--p-tangerine-600)] shadow-md group-hover:scale-105 transition-transform duration-300 flex-shrink-0"
                  >
                    <i class="pi pi-chart-line !text-base sm:!text-lg text-white"></i>
                  </div>
                  <div
                    class="text-sm sm:text-base font-bold text-[var(--p-anthracite-500)] min-w-0 flex-1"
                  >
                    Used Commission Earned YTD
                  </div>
                </div>
                <div
                  class="text-xl sm:text-2xl font-bold text-[var(--p-primary-600)] mb-1 sm:mb-2 transition-all duration-300 relative tracking-tight break-words"
                >
                  {{ formatCurrency.format(usedCommissionEarnedYtd) }}
                </div>
              </div>
            </div>

            <div
              class="group relative bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-[0_10px_25px_-5px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] border border-[var(--p-surface-200)] transition-all duration-300 animate-[fadeInUp_0.6s_ease-out_0.2s] hover:shadow-[0_15px_35px_-5px_rgba(0,0,0,0.15),0_6px_10px_-3px_rgba(0,0,0,0.1)] hover:-translate-y-1 hover:border-[var(--p-primary-300)] overflow-hidden"
              v-tooltip.left="
                'This is the total new car finance commission earned year to date for the selected scope.'
              "
            >
              <div
                class="absolute inset-0 bg-gradient-to-br from-sky-50/0 to-sky-50/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
              ></div>
              <div class="relative">
                <div class="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3">
                  <div
                    class="w-9 h-9 sm:w-10 sm:h-10 rounded-lg sm:rounded-xl flex items-center justify-center text-white bg-gradient-to-br from-[var(--p-mint-500)] to-[var(--p-mint-600)] shadow-md group-hover:scale-105 transition-transform duration-300 flex-shrink-0"
                  >
                    <i class="pi pi-car !text-base sm:!text-lg text-white"></i>
                  </div>
                  <div
                    class="text-sm sm:text-base font-bold text-[var(--p-anthracite-500)] min-w-0 flex-1"
                  >
                    New Commission Earned YTD
                  </div>
                </div>
                <div
                  class="text-xl sm:text-2xl font-bold text-[var(--p-primary-600)] mb-1 sm:mb-2 transition-all duration-300 relative tracking-tight break-words"
                >
                  {{ formatCurrency.format(newCommissionEarnedYtd) }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="performanceStatus && performanceInsights.length > 0"
            class="w-full bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-[0_10px_25px_-5px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] border border-[var(--p-surface-200)] animate-[fadeInUp_0.6s_ease-out_0.4s] mt-4 sm:mt-5 mb-0"
          >
            <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
              <div
                class="flex items-center gap-2 sm:gap-3 px-3 sm:px-4 py-2 sm:py-2.5 rounded-lg bg-gradient-to-br from-[var(--p-primary-50)] to-[var(--p-primary-100)] border border-[var(--p-primary-200)] w-full sm:w-auto"
              >
                <div
                  :class="[
                    'w-8 h-8 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center text-white text-base sm:text-lg flex-shrink-0',
                    performanceStatus.color === 'mint'
                      ? 'bg-gradient-to-br from-[var(--p-mint-500)] to-[var(--p-mint-600)]'
                      : performanceStatus.color === 'tangerine'
                        ? 'bg-gradient-to-br from-[var(--p-tangerine-500)] to-[var(--p-tangerine-600)]'
                        : 'bg-gradient-to-br from-[var(--p-primary-500)] to-[var(--p-primary-600)]',
                  ]"
                >
                  <i :class="`pi ${performanceStatus.icon} text-white`"></i>
                </div>
                <div class="min-w-0 flex-1">
                  <div
                    class="text-xs font-semibold text-[var(--p-anthracite-500)] uppercase tracking-wide mb-0.5"
                  >
                    Status
                  </div>
                  <div class="text-xs sm:text-sm font-bold text-[var(--p-anthracite-500)] truncate">
                    {{ performanceStatus.label }}
                  </div>
                </div>
              </div>

              <div class="flex-1 min-w-0 w-full sm:w-auto">
                <div class="flex flex-col gap-2">
                  <div
                    v-for="(insight, index) in performanceInsights"
                    :key="index"
                    :class="[
                      'flex items-start gap-2 sm:gap-2.5 px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-md text-xs sm:text-sm',
                      insight.type === 'success'
                        ? 'bg-green-50 border border-green-200 text-green-800'
                        : insight.type === 'warning'
                          ? 'bg-orange-50 border border-orange-200 text-orange-800'
                          : 'bg-[var(--p-primary-50)] border border-[var(--p-primary-200)] text-[var(--p-anthracite-500)]',
                    ]"
                  >
                    <i
                      :class="[
                        'pi flex-shrink-0 mt-0.5 text-sm',
                        insight.type === 'success'
                          ? 'pi-check-circle text-green-600'
                          : insight.type === 'warning'
                            ? 'pi-exclamation-triangle text-orange-600'
                            : 'pi-info-circle text-[var(--p-primary-600)]',
                      ]"
                    ></i>
                    <span class="font-medium break-words">{{ insight.message }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isUpdating && hasNoData" class="flex items-center w-full">
      <div
        class="w-full bg-white rounded-2xl p-8 shadow-[0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] border border-[var(--p-surface-200)]"
      >
        <div
          class="w-20 h-20 mx-auto mb-6 rounded-full bg-[var(--p-surface-200)] animate-pulse"
        ></div>
        <div class="h-8 w-48 bg-[var(--p-surface-200)] rounded mx-auto mb-3 animate-pulse"></div>
        <div class="h-4 w-64 bg-[var(--p-surface-200)] rounded mx-auto mb-6 animate-pulse"></div>
        <div class="space-y-2 mb-6 max-w-xs mx-auto">
          <div class="h-3 w-full bg-[var(--p-surface-200)] rounded animate-pulse"></div>
          <div class="h-3 w-full bg-[var(--p-surface-200)] rounded animate-pulse"></div>
          <div class="h-3 w-3/4 bg-[var(--p-surface-200)] rounded animate-pulse"></div>
        </div>
        <div class="h-3 w-56 bg-[var(--p-surface-200)] rounded mx-auto animate-pulse"></div>
      </div>
    </div>

    <div v-else-if="hasNoData && !isUpdating" class="flex items-center w-full">
      <div
        class="w-full bg-white rounded-2xl p-8 shadow-[0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] border border-[var(--p-surface-200)] text-center animate-[fadeInUp_0.6s_ease-out]"
      >
        <div
          class="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-[var(--p-orange-100)] to-[var(--p-orange-200)] flex items-center justify-center"
        >
          <i class="pi pi-inbox !text-4xl text-[var(--p-orange-500)]"></i>
        </div>
        <h3 class="text-2xl font-bold text-[var(--p-anthracite-500)] mb-3">No Data Available</h3>
        <p class="text-base text-[var(--p-anthracite-500)] mb-6 leading-relaxed">
          No performance data is available for the current selection. This may be because:
        </p>
        <ul class="text-left text-sm text-[var(--p-anthracite-500)] space-y-2 mb-6 max-w-xs mx-auto">
          <li class="flex items-center gap-2">
            <i
              class="pi pi-circle-fill text-[0.5rem] text-[var(--p-anthracite-500)] flex-shrink-0"
            ></i>
            <span>No tracker data has been imported</span>
          </li>
          <li class="flex items-center gap-2">
            <i
              class="pi pi-circle-fill text-[0.5rem] text-[var(--p-anthracite-500)] flex-shrink-0"
            ></i>
            <span>The selected retailer or group has no records</span>
          </li>
          <li class="flex items-center gap-2">
            <i
              class="pi pi-circle-fill text-[0.5rem] text-[var(--p-anthracite-500)] flex-shrink-0"
            ></i>
            <span>No target has been set for the selected option.</span>
          </li>
        </ul>
        <div
          class="mt-6 pt-6 border-t border-[var(--p-surface-200)] text-xs text-[var(--p-anthracite-500)]"
        >
          <p>Try another option or contact support for further assistance.</p>
        </div>
      </div>
    </div>

    <div v-show="scope == 'Group' && !hasNoData" class="mt-4 space-y-6">
      <DataGrid
        :config="TrackerConfiguration"
        :type="'Performance Bonus'"
        :scope="scope"
        :retailer="retailer"
        :group="group"
        :dataKey="'data'"
        :includeProposedNotFunded="includeProposedNotFunded"
        :enableTrackerExtras="true"
        :presetYear="props.year"
        @turnover="handleEmit"
        @loading-change="handleLoadingChange"
        @row-click="(row: Record<string, unknown>) => handleRowClick(row, 'yearly')"
        @year-change="handleYearChange"
      />
      <DataGrid
        :config="TrackerMonthlyConfiguration"
        :type="'Performance Bonus Monthly'"
        :scope="scope"
        :retailer="retailer"
        :group="group"
        :dataKey="'data'"
        :includeProposedNotFunded="includeProposedNotFunded"
        :presetYear="props.year"
        @row-click="(row: Record<string, unknown>) => handleRowClick(row, 'monthly')"
        @period-change="handleMonthlyPeriodChange"
        @year-change="handleYearChange"
      />
    </div>

    <div v-show="scope == 'Retailer' && !hasNoData" class="mt-4 space-y-6">
      <DataGrid
        :config="FinancedDealsConfiguration"
        type="Financed Deals"
        scope="Retailer"
        :retailer="retailer"
        :presetYear="props.year"
        @year-change="handleYearChange"
      />
      <DataGrid
        :config="AcceptedNotFundedConfiguration"
        type="Accepted Not Funded Cases"
        scope="Retailer"
        :retailer="retailer"
        :presetYear="props.year"
        @year-change="handleYearChange"
      />
      <DataGrid
        :config="EarlySettlementCasesConfiguration"
        type="Early Settlement Cases"
        scope="Retailer"
        :retailer="retailer"
        :presetYear="props.year"
        @year-change="handleYearChange"
      />
      <DataGrid
        :config="TrackerMonthlyConfiguration"
        :type="'Performance Bonus Monthly'"
        scope="Retailer"
        :retailer="retailer"
        :dataKey="'data'"
        :includeProposedNotFunded="includeProposedNotFunded"
        :presetYear="props.year"
        @row-click="(row: Record<string, unknown>) => handleRetailerLevelRowClick(row, 'monthly')"
        @period-change="handleMonthlyPeriodChange"
        @year-change="handleYearChange"
      />
    </div>

    <Dialog
      v-model:visible="retailerDialogVisible"
      modal
      header="Performance Tracker - Retailer Drilldown"
      :style="{ width: '90vw', maxWidth: '1200px' }"
      class="retailer-details-dialog"
    >
      <div class="py-2">
        <div
          class="flex items-center gap-3 mb-4 p-4 bg-[var(--p-surface-50)] rounded-lg border border-[var(--p-surface-200)]"
        >
          <div
            class="w-12 h-12 bg-[var(--p-primary-100)] rounded-xl flex items-center justify-center"
          >
            <i class="pi pi-building !text-2xl text-white"></i>
          </div>
          <div class="flex items-center gap-3">
            <div>
              <div class="text-sm text-[var(--p-anthracite-500)] font-medium mb-1">Retailer Code</div>
              <div class="text-lg font-bold text-[var(--p-anthracite-500)]">
                {{ selectedRetailer?.code }}
              </div>
            </div>
            <div class="flex-1 ml-4">
              <div class="text-sm text-[var(--p-anthracite-500)] font-medium mb-1">Retailer Name</div>
              <div class="text-lg font-semibold text-[var(--p-anthracite-500)]">
                {{ selectedRetailer?.name }}
              </div>
            </div>
          </div>
        </div>

        <template v-if="drilldownMode === 'monthly'">
          <DataGrid
            :config="TrackerDrilldownConfiguration"
            :type="'Performance Bonus Monthly Drilldown'"
            scope="Retailer"
            :retailer="retailerObject"
            :includeProposedNotFunded="includeProposedNotFunded"
            :presetPeriod="monthlyPeriod"
            :presetYear="props.year"
          />
        </template>
        <template v-else>
          <Tabs>
            <TabList>
              <Tab value="finance">Finance Cases</Tab>
              <Tab value="accepted">Accepted Not Funded Cases</Tab>
              <Tab value="cancelled">Cancelled/Early Settlements</Tab>
            </TabList>
            <TabPanels class="!p-0">
            <TabPanel value="finance" class="p-0">
              <DataGrid
                :config="FinancedDealsConfiguration"
                type="Financed Deals"
                scope="Retailer"
                :retailer="retailerObject"
                :hideHeader="true"
                :presetYear="props.year"
                @year-change="handleYearChange"
              />
            </TabPanel>
            <TabPanel value="accepted">
              <DataGrid
                :config="AcceptedNotFundedConfiguration"
                type="Accepted Not Funded Cases"
                scope="Retailer"
                :retailer="retailerObject"
                :hideHeader="true"
                :presetYear="props.year"
                @year-change="handleYearChange"
              />
            </TabPanel>
            <TabPanel value="cancelled">
              <DataGrid
                :config="EarlySettlementCasesConfiguration"
                type="Early Settlement Cases"
                scope="Retailer"
                :retailer="retailerObject"
                :hideHeader="true"
                :presetYear="props.year"
                @year-change="handleYearChange"
              />
            </TabPanel>
            </TabPanels>
          </Tabs>
        </template>
      </div>
    </Dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { TrackerConfiguration } from '../config/grids/TrackerConfiguration'
import { TrackerMonthlyConfiguration } from '../config/grids/TrackerMonthlyConfiguration'
import { TrackerDrilldownConfiguration } from '../config/grids/TrackerDrilldownConfiguration'
import { EarlySettlementCasesConfiguration } from '../config/grids/EarlySettlementCasesConfiguration'
import { FinancedDealsConfiguration } from '../config/grids/FinancedDealsConfiguration'
import { AcceptedNotFundedConfiguration } from '../config/grids/AcceptedNotFundedConfiguration'
import type { TurnoverData } from '@/config/types/BonusTracker'

const props = defineProps(['scope', 'retailer', 'group', 'year'])
const emit = defineEmits(['year-change'])

const retailerDialogVisible = ref(false)
const selectedRetailer = ref<{ code?: string; name?: string } | null>(null)
const includeProposedNotFunded = ref(false)
const drilldownMode = ref<'yearly' | 'monthly'>('yearly')
const monthlyPeriod = ref<string | string[] | null>(null)

const retailerObject = computed(() => {
  return selectedRetailer.value?.code ? { bank_code: selectedRetailer.value.code } : null
})

const handleRowClick = (rowData: Record<string, unknown>, mode: 'yearly' | 'monthly') => {
  selectedRetailer.value = {
    code: String(rowData.code || ''),
    name: String(rowData.name || ''),
  }
  drilldownMode.value = mode
  retailerDialogVisible.value = true
}

const handleRetailerLevelRowClick = (rowData: Record<string, unknown>, mode: 'yearly' | 'monthly') => {
  // At Retailer level, use the retailer from props since we're already viewing a specific retailer
  if (props.retailer) {
    selectedRetailer.value = {
      code: String(props.retailer.bank_code || props.retailer.code || ''),
      name: String(props.retailer.label || props.retailer.name || ''),
    }
  } else {
    // Fallback to row data if retailer prop is not available
    selectedRetailer.value = {
      code: String(rowData.code || ''),
      name: String(rowData.name || ''),
    }
  }
  drilldownMode.value = mode
  retailerDialogVisible.value = true
}

const handleMonthlyPeriodChange = (period: string | string[]) => {
  monthlyPeriod.value = period
}

const handleYearChange = (year: string) => {
  emit('year-change', year)
}

const handleIncludeProposedChange = () => {}

const handleLoadingChange = (isLoading: boolean) => {
  if (!isDataLoaded.value) return
  isUpdating.value = isLoading
}

const performanceStatus = computed(() => {
  if (usedAnticipatedRaw.value === 0) return null
  const percentage = usedTurnoverPerformance.value
  const currentMonth = new Date().getMonth() + 1
  const expectedProgress = (currentMonth / 12) * 100

  if (percentage >= expectedProgress + 5) {
    return { label: 'Ahead of Anticipated Volume', color: 'mint', icon: 'pi-arrow-up' }
  } else if (percentage >= expectedProgress - 5) {
    return { label: 'On Track', color: 'primary', icon: 'pi-check-circle' }
  } else {
    return {
      label: 'Behind Anticipated Volume',
      color: 'tangerine',
      icon: 'pi-exclamation-triangle',
    }
  }
})

const performanceInsights = computed(() => {
  const insights: Array<{ type: 'success' | 'warning' | 'info'; message: string }> = []
  if (usedAnticipatedRaw.value === 0) return insights

  const percentage = usedTurnoverPerformance.value
  const currentMonth = new Date().getMonth() + 1
  const expectedProgress = (currentMonth / 12) * 100
  const variance = percentage - expectedProgress

  if (variance > 5) {
    insights.push({
      type: 'success',
      message: `Performing ${variance.toFixed(1)}% above expected progress for this point in the year`,
    })
  } else if (variance < -5) {
    insights.push({
      type: 'warning',
      message: `${Math.abs(variance).toFixed(1)}% below expected progress.`,
    })
  } else {
    insights.push({
      type: 'info',
      message: 'Performance is aligned with expected progress for the current period.',
    })
  }

  if (untilAnticipated.value > 0 && untilAnticipated.value < usedAnticipated.value * 0.1) {
    insights.push({
      type: 'success',
      message: `Only ${formatCurrency.format(untilAnticipated.value)} remaining to reach the annual target.`,
    })
  }

  return insights
})

const totalTurnover = ref(0)
const actualTurnover = ref(0)
const actualTurnoverRaw = ref(0)
const usedAnticipated = ref(0)
const usedAnticipatedRaw = ref(0)
const newCommissionEarnedYtd = ref(0)
const usedCommissionEarnedYtd = ref(0)
const untilAnticipated = ref(0)
const usedTurnoverPerformance = ref(0)
const isDataLoaded = ref(false)
const hasNoData = ref(false)
const isUpdating = ref(false)

const formatCurrency = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  maximumFractionDigits: 2,
})

const resetMetrics = () => {
  totalTurnover.value = 0
  actualTurnover.value = 0
  actualTurnoverRaw.value = 0
  usedAnticipated.value = 0
  usedAnticipatedRaw.value = 0
  newCommissionEarnedYtd.value = 0
  usedCommissionEarnedYtd.value = 0
  untilAnticipated.value = 0
  usedTurnoverPerformance.value = 0
}

const handleEmit = (data: TurnoverData) => {
  if (isDataLoaded.value) {
    isUpdating.value = true
  }

  if (!data.target) {
    resetMetrics()
    setTimeout(() => {
      hasNoData.value = true
      isDataLoaded.value = true
      setTimeout(() => {
        isUpdating.value = false
      }, 200)
    }, 300)
    return
  }

  hasNoData.value = false
  actualTurnoverRaw.value = data.data.reduce((acc, record) => acc + record.total_turnover, 0)
  usedAnticipatedRaw.value = data.target.used_total_turnover_target

  isDataLoaded.value = true

  let actualUsed = 0
  data.data.forEach((record) => (actualUsed += record.total_turnover))

  requestAnimationFrame(() => {
    isUpdating.value = false

    handleCounter(data.projected_turnover || 0, totalTurnover, 600)
    handleCounter(actualUsed, actualTurnover, 600)
    handleCounter(data.target.used_total_turnover_target, usedAnticipated, 600)
    handleCounter(data.new_commission_earned_ytd || 0, newCommissionEarnedYtd, 600)
    handleCounter(data.used_commission_earned_ytd || 0, usedCommissionEarnedYtd, 600)

    const anticipated = data.target.used_total_turnover_target - actualUsed
    handleCounter(anticipated < 0 ? 0 : anticipated, untilAnticipated, 600)
    handleCounter(
      (actualUsed / data.target.used_total_turnover_target) * 100,
      usedTurnoverPerformance,
      600,
    )
  })
}

const handleCounter = async (number: number, target: { value: number }, duration: number = 600) => {
  const startValue = target.value
  const endValue = number
  const startTime = performance.now()

  const animate = (currentTime: number) => {
    const elapsed = currentTime - startTime
    const progress = Math.min(elapsed / duration, 1)

    const easeOut = 1 - Math.pow(1 - progress, 3)
    const currentValue = startValue + (endValue - startValue) * easeOut

    target.value = Math.round(currentValue * 100) / 100

    if (progress < 1) {
      requestAnimationFrame(animate)
    } else {
      target.value = endValue
    }
  }

  requestAnimationFrame(animate)
}
</script>

<style scoped>
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1.15);
  }
}

.dark-selector .metric-card {
  background: var(--p-surface-800);
  border-color: var(--p-surface-700);
}

.dark-selector .metric-label {
  color: var(--p-anthracite-500);
}

.dark-selector .metric-value {
  color: var(--p-anthracite-500);
}

.dark-selector .performance-title {
  color: var(--p-anthracite-500);
}

.dark-selector .performance-subtitle {
  color: var(--p-anthracite-500);
}

.dark-selector .section-title {
  color: var(--p-anthracite-500);
}

.dark-selector .section-subtitle {
  color: var(--p-anthracite-500);
}

.dark-selector .loading-title {
  color: var(--p-anthracite-500);
}

.dark-selector .loading-subtitle {
  color: var(--p-anthracite-500);
}

.a11y-high-contrast .metric-card {
  border: 2px solid var(--p-primary-500);
}

.a11y-high-contrast .tracker-header {
  border: 2px solid white;
}

.a11y-reduced-motion .metric-card {
  transition: none;
}

.a11y-reduced-motion .metric-card:hover {
  transform: none;
}

.metric-card:hover .metric-icon {
  transform: scale(1.1);
  transition: transform 0.2s ease;
}

.metric-card:hover .metric-value {
  color: var(--p-primary-600);
  transition: color 0.2s ease;
}

.metric-card:focus-within {
  outline: 2px solid var(--p-primary-500);
  outline-offset: 2px;
}

@media print {
  .tracker-header {
    background: white;
    color: black;
    border: 1px solid black;
  }

  .metric-card {
    border: 1px solid black;
    box-shadow: none;
  }
}

.retailer-details-dialog :deep(.p-dialog-header) {
  background: linear-gradient(135deg, var(--p-primary-500) 0%, var(--p-primary-600) 100%);
  color: white;
  border-radius: 0.5rem 0.5rem 0 0;
}

.retailer-details-dialog :deep(.p-dialog-header-icon) {
  color: white;
}

.retailer-details-dialog :deep(.p-dialog-header-icon:hover) {
  background: rgba(255, 255, 255, 0.1);
}
</style>
